export default "__VITE_ASSET__DIpLCy2$__"